import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    //TBD
    error: {
      color: theme.palette.error.main,
    },
  };
});

export { useStyles };
